class NovDiag {
    constructor(el, options = {}){ 
        this.diag = el;
        this.stepCurrent = 0;
        this.diagData = {};
        this.diagDataForEgality = {};
        this.saveDiagData = [];
        this.customerData = {};
        this.contentProgressBar = ""; 
        this.countStep = document.querySelectorAll(".content-step").length;  
        this.options = Object.assign(
            {},
            {  
                mode: "guest", 
                sendConfig: {
                    klav: false,
                    account: false,
                    save: false,
                    connexionUrl: ""
                },
                customer : {
                    id : "",
                    prenom : "",
                    email : ""
                } 
            }, 
            options
        );    
        document.querySelectorAll(".btn-skip").forEach(skip => {
            skip.addEventListener("click", () => { 
                this.goToStep(this.stepCurrent+1);
            });
        });  

        if(this.options.customer.prenom != ""){
            this.diag.querySelector("input[name='prenom']").value = this.options.customer.prenom;
        }

        if(this.options.customer.email != ""){
            this.diag.querySelectorAll("input[name='email']").forEach(iName => {
                iName.value = this.options.customer.email;
            });
        }

        document.addEventListener('keyup', (e) => {
            if(e.code == "Enter" && document.querySelectorAll(".content-step")[this.stepCurrent].querySelector(".btn-confirm") != null){
                document.querySelectorAll(".content-step")[this.stepCurrent].querySelector(".btn-confirm").click();
            } 
        });

        if(document.querySelector(".klav-radio") != null){
            document.querySelector(".klav-radio").addEventListener("click", function(){ 
                if(this.classList.contains("selected")){
                    this.classList.remove("selected"); 
                }else{
                    this.classList.add("selected"); 
                } 
            });
        }

        //Events
        document.querySelectorAll(".content-step").forEach((cstep, index) => {
            var step = cstep.querySelector(".step");
            step.setAttribute("data-index", index);
            var type = cstep.getAttribute("data-type");
            var mode = cstep.getAttribute("data-mode");  
            var egalityMaster = parseInt(cstep.getAttribute("data-egality-master"));  

            /* CHECKBOX */
            if(type == "checkbox"){
                step.querySelectorAll(".choix").forEach(a => { 
                    a.addEventListener("click", () => {  

                        if(mode == "solo"){
                            var type = a.getAttribute("data-type");  
                            if(type == "scoring"){
                                var dataScore = a.dataset;   
                                var groupId = a.getAttribute("data-group-id");
                                if(typeof this.diagData[groupId] == "undefined"){
                                    this.diagData[groupId] = {};
                                }
                                if(typeof this.diagDataForEgality[groupId] == "undefined"){
                                    this.diagDataForEgality[groupId] = {};
                                }
                                Object.entries(dataScore).forEach(d => {  
                                    if((d[0].includes("p-") || d[0].includes("m-")) && !d[0].includes("Mode") && typeof this.diagData[groupId][d[0]] == "undefined"){
                                        this.diagData[groupId][d[0]] = {
                                            "total" : 0
                                        } 
                                    } 
                                    if((d[0].includes("p-") || d[0].includes("m-")) && !d[0].includes("Mode") && typeof this.diagDataForEgality[groupId][d[0]] == "undefined" && egalityMaster){
                                        this.diagDataForEgality[groupId][d[0]] = {
                                            "total" : 0
                                        }
                                    }
                                }); 
                                if(!a.classList.contains("select")){ 
                                    var allRep = a.closest(".content-choix").querySelectorAll(".choix");
                                    allRep.forEach(rep => {
                                        if(rep.classList.contains("select")){
                                            rep.classList.remove("select");
                                        }
                                    });
                                    Object.entries(dataScore).forEach(d => { 
                                        if((d[0].includes("p-") || d[0].includes("m-")) && !d[0].includes("Mode")){
                                            let modeDataKey = "data-" + d[0] + "-mode";
                                            if(typeof a.getAttribute(modeDataKey) != "undefined"){
                                                if(a.getAttribute(modeDataKey) == "add"){
                                                    this.diagData[groupId][d[0]].total += parseInt(d[1]); 
                                                    if(egalityMaster){ 
                                                        this.diagDataForEgality[groupId][d[0]].total += parseInt(d[1]); 
                                                    }
                                                }else{
                                                    this.diagData[groupId][d[0]].total -= parseInt(d[1]); 
                                                    if(egalityMaster){ 
                                                        this.diagDataForEgality[groupId][d[0]].total -= parseInt(d[1]); 
                                                    }
                                                }
                                            } 
                                        }
                                    });
                                    a.classList.add("select"); 
                                }       
                                this.goToStep(this.stepCurrent+1);
                            }
                            if(type == "customer"){
                                if(!a.classList.contains("select")){ 
                                    var allRep = a.closest(".content-choix").querySelectorAll(".choix");
                                    allRep.forEach(rep => {
                                        if(rep.classList.contains("select")){
                                            rep.classList.remove("select");
                                        }
                                    });
                                    var name = a.getAttribute("data-name");
                                    var value = a.getAttribute("data-value"); 
                                    this.customerData[name] = value; 
                                    a.classList.add("select");  
                                }    
                                var value = a.innerHTML;  
                                this.goToStep(this.stepCurrent+1);
                            }
                        }else{
                            var dataScore = a.dataset;   
                            var groupId = a.getAttribute("data-group-id");
                            if(typeof this.diagData[groupId] == "undefined"){
                                this.diagData[groupId] = {};
                            }
                            if(typeof this.diagDataForEgality[groupId] == "undefined"){
                                this.diagDataForEgality[groupId] = {};
                            }
                            Object.entries(dataScore).forEach(d => {  
                                if((d[0].includes("p-") || d[0].includes("m-")) && !d[0].includes("Mode") && typeof this.diagData[groupId][d[0]] == "undefined"){
                                    this.diagData[groupId][d[0]] = {
                                        "total" : 0
                                    } 
                                } 
                                if((d[0].includes("p-") || d[0].includes("m-")) && !d[0].includes("Mode") && typeof this.diagDataForEgality[groupId][d[0]] == "undefined" && egalityMaster){
                                    this.diagDataForEgality[groupId][d[0]] = {
                                        "total" : 0
                                    }
                                }
                            });
                            if(!a.classList.contains("select")){ 
                                a.classList.add("select");
                                Object.entries(dataScore).forEach(d => { 
                                    if((d[0].includes("p-") || d[0].includes("m-")) && !d[0].includes("Mode")){
                                        let modeDataKey = "data-" + d[0] + "-mode";
                                        if(typeof a.getAttribute(modeDataKey) != "undefined"){
                                            if(a.getAttribute(modeDataKey) == "add"){
                                                this.diagData[groupId][d[0]].total += parseInt(d[1]); 
                                                if(egalityMaster){
                                                    this.diagDataForEgality[d[0]].total += parseInt(d[1]); 
                                                }
                                            }else{
                                                this.diagData[groupId][d[0]].total -= parseInt(d[1]); 
                                                if(egalityMaster){
                                                    this.diagDataForEgality[d[0]].total -= parseInt(d[1]); 
                                                }
                                            }
                                        } 
                                    }
                                });
                            }else{ 
                                a.classList.remove("select");
                                Object.entries(dataScore).forEach(d => { 
                                    if((d[0].includes("p-") || d[0].includes("m-")) && !d[0].includes("Mode")){
                                        let modeDataKey = "data-" + d[0] + "-mode";
                                        if(typeof a.getAttribute(modeDataKey) != "undefined"){
                                            if(a.getAttribute(modeDataKey) == "add"){
                                                this.diagData[groupId][d[0]].total += parseInt(d[1]); 
                                                if(egalityMaster){
                                                    this.diagDataForEgality[d[0]].total += parseInt(d[1]); 
                                                }
                                            }else{
                                                this.diagData[groupId][d[0]].total -= parseInt(d[1]); 
                                                if(egalityMaster){
                                                    this.diagDataForEgality[d[0]].total -= parseInt(d[1]); 
                                                }
                                            }
                                        } 
                                    }
                                });
                            }
                        } 
                    }); 
                });

                if(mode == "multiple"){
                    step.querySelector(".btn-confirm").addEventListener("click", () => { 
                        if(step.querySelectorAll(".choix.select").length > 0){   
                            this.goToStep(this.stepCurrent+1);
                            this.killError();
                        }else{
                            this.showError("Vous devez séléctionner au moins un champs.", 3500);
                        }
                    });
                }
            }

            /* FIELDS */
            if(type == "field"){
                step.querySelector(".btn-confirm").addEventListener("click", () => {
                    var field = step.querySelector(".field input");
                    var name = field.getAttribute("name");
                    var value = field.value;
                    if(value != ""){ 
                        this.killError();
                        this.customerData[name] = value;  
                        if(name == "prenom"){
                            this.checkForName(value);
                        } 
                        this.goToStep(this.stepCurrent+1);
                    }else{
                        this.showError("Vous devez remplir le champs.", 3500);
                    }
                });
            }

            if(type == "final"){
                step.querySelectorAll(".btn-confirm").forEach(btn => {
                    btn.addEventListener("click", () => {

                        if(btn.classList.contains("klav")){
                            var field = step.querySelector(".field input");
                            var name = field.getAttribute("name");
                            var value = field.value;
                            if(value != ""){ 
                                this.killError();
                                this.customerData[name] = value;    
                                this.goToStep(this.stepCurrent+1); 
                            }else{
                                this.showError("Vous devez remplir le champs.", 3500);
                            }
                        }else if(btn.classList.contains("guest")){
                            this.options.sendConfig.connexionUrl = btn.getAttribute("data-href");
                            this.options.sendConfig.save = true;
                            if(document.querySelector(".klav-radio") != null){
                                if(document.querySelector(".klav-radio").classList.contains("selected")){
                                    this.options.sendConfig.klav = true;
                                }else{
                                    this.options.sendConfig.klav = false;
                                }
                            }  
                            this.goToStep(this.stepCurrent+1);
                        }else{ 
                            this.goToStep(this.stepCurrent+1);
                        }
                    });
                });   
            }

        });

        //Init
        this.buildFinalLoading();
        this.buildProgressionBar(this.diag, this.countStep, this.stepCurrent); 
        this.goToStep(0); 

        document.querySelectorAll(".back").forEach(bk => { 
            bk.addEventListener("click", () => {  
                this.goToStep(this.stepCurrent -1); 
            }); 
        });

 
    }
 

    buildFinalLoading(){
        let contentFinal = this.createElementWithClass("div", "content-final");
        let content = this.createElementWithClass("div", "content");
        let final = this.createElementWithClass("div", "final");
        let finalLabel1 = this.createElementWithClass("div", "final-label1");
        finalLabel1.textContent = "Chargement de votre résultat...";
        let finalLabel2 = this.createElementWithClass("div", "final-label2");
        let label2 = this.createElementWithClass("div", "label2");
        label2.textContent = "Chargement de votre résultat...";


        let description = this.createElementWithClass("div", "description");
        let descriptionTxt = "Affichage résultat en cours... Impatient(e)? Rdv aussi dans votre boite mail 😉";
        description.innerHTML = descriptionTxt;

        finalLabel2.appendChild(label2);
        final.appendChild(finalLabel1);
        final.appendChild(finalLabel2); 
        content.appendChild(final);
        content.appendChild(description);
        contentFinal.appendChild(content);
        this.diag.appendChild(contentFinal); 
    } 

    progressLoadingResult(){
        this.diag.querySelector(".content-final").classList.add("show");
        setTimeout(() => {
            this.diag.querySelector(".content-final .final .final-label2").classList.add("loading");
        }, 100); 
    }

    progressLoadingEnd(url){  
        this.diag.querySelector(".content-final .final .final-label2").classList.add("end");   
        if(!this.options.sendConfig.save){
            this.diag.querySelector(".content-final .final .final-label2 .label2").textContent = "Chargement de votre résultat...";
            this.diag.querySelector(".content-final .final .final-label1").textContent = "Chargement de votre résultat...";
            // ajouter seconde ligne Impatient ? Votre résultat se trouve aussi dans votre boite mail.
        } 
        setTimeout(() => {
            window.location.href = url;
        }, 4000);
    }

    buildProgressionBar(el, nbStep, current){
        let contentProgressBar = this.createElementWithClass("div", "content-progress-bar");
        let progressBar = this.createElementWithClass("div", "progress-bar");
        let progressBarCursor = this.createElementWithClass("div", "progress-cursor");
        progressBarCursor.classList.add("hide");
        let progressBarCursorCurrent = this.createElementWithClass("div", "current");
        progressBarCursorCurrent.textContent = current;
        let progressBarCursorCountStep = this.createElementWithClass("div", "count");
        progressBarCursorCountStep.textContent = "/" + nbStep;

        progressBarCursor.appendChild(progressBarCursorCurrent);
        progressBarCursor.appendChild(progressBarCursorCountStep);
        progressBar.appendChild(progressBarCursor);
        contentProgressBar.appendChild(progressBar);

        el.appendChild(contentProgressBar);
        this.contentProgressBar = contentProgressBar;
    }

    progressionBar(nbStep, current){
        var calWidthBar = Math.round(current * 100 / nbStep); 
        this.contentProgressBar.querySelector(".progress-bar").style.width = calWidthBar + "%";
        this.contentProgressBar.querySelector(".progress-bar .current").textContent = current;
        if(current > 0 && this.contentProgressBar.querySelector(".progress-cursor.hide") != null){
            this.contentProgressBar.querySelector(".progress-cursor").classList.remove("hide");
        }
    }

    createElementWithClass(type, className){
        var element = document.createElement(type);
        element.classList.add(className);
        return element;
    }

    killError(){
        var errors = document.querySelectorAll(".content-error");
        if(errors.length > 0){
            errors.forEach(e => {
                e.remove();
            })
        }
    }

    showError(message, time){
        this.killError();
        var contentError = document.createElement("div");
        contentError.classList.add("content-error");
        var error = document.createElement("div");
        error.classList.add("error");
        error.innerHTML = message;
        contentError.appendChild(error);
        document.querySelector("body").appendChild(contentError);
        setTimeout(() => {
            contentError.classList.add("show");
        },100); 
        setTimeout(() => {
            contentError.remove();
        }, time);
    }

    checkForName(name){
        document.querySelectorAll(".content-step .step .content-desc .desc h2").forEach(desc => {
            var texte = desc.textContent;  
            var newTexte = texte.replace("[Prénom]", name);  
            desc.textContent = newTexte; 
        }); 
    }

    saveDiag(){
        let checkSteps = localStorage.getItem("steps"); 
        if(checkSteps == null){
            let stepsC = [];
            let dToPush = this.diagSave;
            stepsC.push(dToPush); 
            localStorage.setItem("steps", JSON.stringify(stepsC));
        }else{
            let steps = JSON.parse(checkSteps); 
            let dToPush = this.diagSave; 
            steps.push(dToPush); 
            localStorage.setItem("steps", JSON.stringify(steps));
        } 
    }

    goToStep(index){     
        var back = false;
        if(index < this.stepCurrent){
            back = true;
        } 
        if(index <= 0){ 
            this.stepCurrent = 0; 
            localStorage.removeItem('steps');
        }else{
            this.stepCurrent = index; 
            this.saveDiag();
        }
        if(back){  
            if(document.querySelectorAll(".content-step")[this.stepCurrent].classList.contains("off")){
                this.goToStep(this.stepCurrent-1);
                return;
            }
            this.progressionBar(this.countStep, this.stepCurrent); 
            document.querySelectorAll(".content-step")[this.stepCurrent].classList.remove("checked");  
            document.querySelectorAll(".content-step")[this.stepCurrent+1].classList.add("off"); 
            document.querySelectorAll(".content-step")[this.stepCurrent].querySelectorAll(".choix").forEach(choix => { 
                choix.classList.remove("select"); 
            });
            let checkSteps = localStorage.getItem("steps"); 
            if(checkSteps != null){
                let steps = JSON.parse(checkSteps);  
                this.diagData = steps[this.stepCurrent-1];
                steps.splice(this.stepCurrent, 1);
                localStorage.setItem("steps", JSON.stringify(steps));
            }  
            if(document.querySelectorAll(".content-step")[this.stepCurrent].getAttribute("data-mode") == "transition"){
                if(this.stepCurrent != 0){
                    this.goToStep(this.stepCurrent-1);
                }else{
                    var timeT = parseInt(document.querySelectorAll(".content-step")[this.stepCurrent].getAttribute("data-time-transition"));
                    setTimeout(() => { 
                        this.goToStep(this.stepCurrent+1);
                    }, timeT);
                } 
            }
            //let toScroll = document.querySelectorAll(".content-step")[index].offsetTop - (window.innerHeight / 2);
            let toScroll = 0;
            if(this.stepCurrent == 0){
                toScroll = document.querySelectorAll(".content-step")[0].offsetTop - 200; 
            }else{
                toScroll = document.querySelectorAll(".content-step")[this.stepCurrent].offsetTop - 200; 
            }

            window.scrollTo({
                top: toScroll,
                behavior: 'smooth',
            });
        }else{ 
  
            if(index >= this.countStep){   
                this.result(); 
            }else{ 
                let now = this.getTime(new Date());
                document.querySelectorAll(".content-step")[index].querySelector(".time").textContent = now; 
                this.progressionBar(this.countStep, this.stepCurrent);
                if(index != 0){
                    document.querySelectorAll(".content-step")[index-1].classList.add("checked"); 
                }

                if(document.querySelectorAll(".content-step")[index].classList.contains("checked")){
                    document.querySelectorAll(".content-step")[index].classList.remove("checked");
                }

                //Gestion filtre
                var checkRepWithFilter = document.querySelectorAll(".content-step")[index].querySelectorAll(".choix[data-name-filter]");
                if(checkRepWithFilter.length > 0){
                    var countRepFiltered = 0;
                    checkRepWithFilter.forEach(rep => { 
                        let name = rep.getAttribute("data-name-filter");
                        let value = rep.getAttribute("data-value-filter");
                        if(value.indexOf(this.customerData[name]) == -1){
                            rep.closest(".c-choix").classList.add("off"); 
                        }else{
                            countRepFiltered++; 
                            if(rep.closest(".c-choix").classList.contains("off")){
                                rep.closest(".c-choix").classList.remove("off");
                            }
                        }
                    }); 
                }
                document.querySelectorAll(".content-step")[index].classList.remove("off"); 
                document.querySelectorAll(".content-step")[index].querySelectorAll(".choix").forEach(choix => {
                    setTimeout(()=> {
                        choix.classList.add("loaded");
                    }, 300);
                });
                if(document.querySelectorAll(".content-step")[index].getAttribute("data-mode") == "transition"){
                    var timeT = parseInt(document.querySelectorAll(".content-step")[index].getAttribute("data-time-transition"));
                    setTimeout(() => { 
                        this.goToStep(this.stepCurrent+1);
                    }, timeT);
                }
                //let toScroll = document.querySelectorAll(".content-step")[index].offsetTop - (window.innerHeight / 2);
                let toScroll = document.querySelectorAll(".content-step")[index].offsetTop - 200; 

                window.scrollTo({
                    top: toScroll,
                    behavior: 'smooth',
                });
            } 
        }
    }
 
    addZero (number){
        if (number < 10) {
            number = "0" + number;
        }
        return number;
    } 

    getTime(date){
        return this.addZero(parseInt(date.getHours())) + ":" + this.addZero(parseInt(date.getMinutes())) + ":" + this.addZero(parseInt(date.getSeconds()));
    }

    removeItemOnce(arr, value) {
        var index = arr.indexOf(value);
        if (index > -1) {
          arr.splice(index, 1);
        }
        return arr;
    }


    /*
    profil(cause, type){
        var c = "";
        var t = "";
        switch(cause){
            case "p-1": c = "alimentation"; break;
            case "p-2": c = "hormones"; break;
            case "p-3": c = "stress"; break;
            case "p-4": c = "cosmetiques"; break; 
            default: c = "";
        }

        switch(type){
            case "m-1": t = "retentionelle"; break;
            case "m-2": t = "mixte"; break;
            case "m-3": t = "inflammatoire"; break; 
            default: t = "";
        }

        return {
            "cause" : c,
            "type" : t
        }
    }
    */

    profil(cursor, profil){
        var c = ""; 
 

        switch(profil){
            case "p-1": c = "a"; break;
            case "p-2": c = "b"; break;
            case "p-3": c = "c"; break;
            case "p-4": c = "d"; break; 
            case "p-5": c = "e"; break; 
            case "p-6": c = "f"; break; 
            default: c = "";
        } 

        return cursor + c;
    }

    checkEgality(obj){
        let highValue = 0; 
        let profilHighValue = "";
        let egality = false;
        let egalityProfil = "";
        Object.entries(obj).forEach(([key, value]) => {
            if(value.total > highValue){
                highValue = value.total;
                profilHighValue = key;
            }
        });
        Object.entries(obj).forEach(([key, value]) => {
            if(value.total == highValue && key != profilHighValue){
                egality = true;
                egalityProfil = key;
            }
        });  
        return {highValue:highValue, profilHighValue:profilHighValue, egality:egality, egalityProfil:egalityProfil};
    }

    checkEgality2(arr){
        let highValue = 0; 
        let profilHighValue = "";
        let egality = false;
        let egalityProfil = [];
        arr.forEach(([key, value]) => {
            if(value > highValue){
                highValue = value;
                profilHighValue = key;
            }
        });
        arr.forEach(([key, value]) => {
            if(value == highValue && key != profilHighValue){
                egality = true;
                egalityProfil.push(key);
            }
        });  
        if(egality){
            egalityProfil.push(profilHighValue);
        }
        return {highValue:highValue, profilHighValue:profilHighValue, egality:egality, egalityProfil:egalityProfil};
    }

    result(){   
        var profil = ""; 
        Object.entries(this.diagData).forEach(([key, value]) => {    
            let sortable = []; 
            Object.entries(value).forEach(([k, v]) => {   
                if(k.includes("p-")){
                    sortable.push([k, v.total]); 
                }  
            }); 
            sortable.sort(function(a, b) {
                return a[1] - b[1];
            }); 
            var sortableR = sortable.reverse();   
            let p = sortableR[0][0];  
            profil += this.profil(key, p);
        });   
 
        this.progressLoadingResult(); 
 
        window.dataLayer = window.dataLayer || []; 

        dataLayer.push({
            'event': 'DiagRoutineEnd' 
        });  
         

        var config = this.options.sendConfig; 

        if(!this.options.sendConfig.save){
            var objToSend = {
                "prenom" : this.customerData.prenom,
                "profil_routine" : profil
            };  
            var callBack = () => {  
                this.progressLoadingEnd("/pages/diagnostic-routine-resultat?id=" + profil);    
            };  
            this.track("", this.customerData.email, objToSend, callBack);
        }else{ 
            this.progressLoadingEnd(this.options.sendConfig.connexionUrl);
            this.setCookie("diag-routine", profil, 1);
            this.setCookie("diag-config", JSON.stringify(config), 1); 
        }    
 
    }

    deleteCookie(name){ 
        document.cookie = name + "= ; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    } 

    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    setCookie(name,value,days) { 
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    } 

    async track(url, email, obj, callBack){  
        var objToString = ""; 
        Object.entries(obj).forEach((field, index) => { 
            objToString += `"${field[0]}" : "${field[1]}"`;  
            if(index < Object.entries(obj).length - 1){
                objToString += "," 
            }
        }); 


        const options = {
            method: 'POST',
            headers: {
                Accept: 'text/html', 
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                data: `{
                    "token": "${app.klaviyo.token}",  
                    "event": "diag-routine", 
                    "customer_properties": {
                        "$email": "${email}",
                        "$consent" : "web"
                    },
                    "properties": {
                        ${objToString}
                    }
                }`
            })
        };

        const trackK = await fetch('https://a.klaviyo.com/api/track', options); 

        if(trackK.ok){
            console.log("tracking klaviyo");  
        }

        await this.checkKlaviyo(email);

        if(typeof callBack == "function"){
            callBack();
        }
         
    } 

    async checkKlaviyo(dataEmail){  
        let options = {
            method: "POST",
            body: JSON.stringify({email: dataEmail, listId: app.klaviyo.list_id})
        };
        const call = await fetch(`${app.aws.url}/klaviyo/checklist`, options);  
        const rep = await call.json();   
        if(JSON.parse(rep.rep.body).length <= 0){ 
            await this.subKlaviyo(dataEmail); 
        } 
    }

    async subKlaviyo(dataEmail){  
        let options = {
            method: "POST",
            body: JSON.stringify({email: dataEmail, listId: app.klaviyo.list_id, source: "diag-routine"})
        };
        const call = await fetch(`${app.aws.url}/klaviyo/subscribe`, options);  
        const rep = await call.json();  
        if(typeof rep.statut != "undefined" && rep.statut == "save"){
            console.log("success"); 
        }  
    }

    get diagSave (){  
        return this.diagData; 
    }
};

  